import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

import css from './ProductsComponent.module.css';
import {ButtonCreate} from "../../../ui/ButtonCreate/ButtonCreate";
import {
    ProductsCreateProductModal
} from "../settingSectionModals/ProductsCreateProductModal/ProductsCreateProductModal";
import ProductsListComponent from "../ProductsListComponent/ProductsListComponent";
import {productsActions, productGroupsActions} from "../../../store/slices/settings-slices";


const ProductsComponent = () => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [groupingMode, setGroupingMode] = useState('flat'); // 'grouped' | 'flat'
    const { productGroups } = useSelector(store => store.productGroups);

    const {handleSubmit, register} = useForm();

    const submit = (data) => {
        dispatch(productsActions.filteredProducts(data.productsSearch));
    }

    const handleClick = () => {
        setIsOpen(true);
    };

    const handleSortChange = (e) => {
        const value = e.target.value;
        if (value === 'createdAt_desc') {
            dispatch(productsActions.setProductsQueryParams({ sortBy: 'createdAt', sortDirection: 'desc' }));
        } else if (value === 'createdAt_asc') {
            dispatch(productsActions.setProductsQueryParams({ sortBy: 'createdAt', sortDirection: 'asc' }));
        } else {
            dispatch(productsActions.setProductsQueryParams({ sortBy: undefined, sortDirection: undefined }));
        }
        // trigger reload
        dispatch(productsActions.changeTrigger());
    };

    useEffect(() => {
        dispatch(productGroupsActions.getAllProductGroups());
    }, [dispatch]);

    const handleGroupChange = (e) => {
        const value = e.target.value;
        if (value === 'no_grouping') {
            setGroupingMode('flat');
            // show all products, without grouping
            dispatch(productsActions.setProductsQueryParams({ groupId: undefined }));
        } else if (value) {
            setGroupingMode('grouped');
            dispatch(productsActions.setProductsQueryParams({ groupId: value }));
        } else {
            // All groups, grouped view
            setGroupingMode('grouped');
            dispatch(productsActions.setProductsQueryParams({ groupId: undefined }));
        }
        dispatch(productsActions.changeTrigger());
    };


    return (
        <section className={css.wrap}>

            <section className={css.titleBlock}>
                <section className={css.btnBlock}>
                    <ButtonCreate onClick={handleClick}/>
                </section>

                <div className={css.controls}>
                    <form onChange={handleSubmit(submit)} className={css.form}>
                        <input className={css.searchInput} type="text" {...register("productsSearch")} placeholder={'Search'}/>
                    </form>

                    <select className={css.sortSelect} onChange={handleGroupChange} defaultValue="no_grouping">
                        <option selected value="no_grouping">No grouping</option>
                        <option value="">All groups</option>
                        {productGroups && productGroups.map((group) => (
                            <option key={group.id} value={group.id}>{group.name?.en}</option>
                        ))}
                    </select>

                    <select className={css.sortSelect} onChange={handleSortChange} defaultValue="createdAt_desc">
                        <option value="createdAt_desc">Created date ↓</option>
                        <option value="createdAt_asc">Created date ↑</option>
                        <option value="none">Default</option>
                    </select>
                </div>
            </section>

            <section className={css.listBlock}>
                <ProductsListComponent groupingMode={groupingMode}/>
            </section>

            {isOpen && <ProductsCreateProductModal setIsOpen={setIsOpen}/>}
        </section>
    );
};

export {ProductsComponent};